import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import api from "../../utilis/api";
import "./pages.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Upcoming = () => {
  const [bookedSlots, setBookedSlots] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentSlot, setCurrentSlot] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const [commentModal, setCommentModal] = useState(false);
  const [comment, setComment] = useState("");

  const formatSlotTime = (time, duration) => {
    if (!time) return "N/A";

    const formatHour = (h) => {
      if (!h) return "";
      const [hourStr, minStr] = h.trim().split(":");
      const hour = parseInt(hourStr);
      const minute = parseInt(minStr) || 0;
      const ampm = hour >= 12 ? "PM" : "AM";
      const h12 = hour % 12 === 0 ? 12 : hour % 12;
      return `${h12}:${minute.toString().padStart(2, "0")} ${ampm}`;
    };

    // Old format: "09:00-10:00"
    if (time.includes("-")) {
      const [start, end] = time.split("-");
      return `${formatHour(start)} - ${formatHour(end)}`;
    }

    // New format: "09:00" — calculate end from duration
    if (duration) {
      const [h, m] = time.split(":").map(Number);
      const totalMin = h * 60 + m + parseInt(duration);
      const endH = String(Math.floor(totalMin / 60)).padStart(2, "0");
      const endM = String(totalMin % 60).padStart(2, "0");
      return `${formatHour(time)} - ${formatHour(`${endH}:${endM}`)}`;
    }

    return formatHour(time);
  };

  // ✅ FIXED: timezone-safe expiry check
  const isSlotExpired = (slot) => {
    try {
      const now = new Date();

      // Get start time string — handle "09:00" and "09:00-10:00"
      const timeStr = slot.time?.includes("-")
        ? slot.time.split("-")[0].trim()
        : slot.time?.trim();

      if (!timeStr) return false;

      const [hourStr, minStr] = timeStr.split(":");
      const startHour = parseInt(hourStr);
      const startMinute = parseInt(minStr) || 0;

      // ✅ Parse date as UTC then convert — avoid timezone shift
      // slot.date is like "2025-04-06T00:00:00.000Z"
      const rawDate = new Date(slot.date);
      // Build local date using UTC year/month/day
      const slotDate = new Date(
        rawDate.getUTCFullYear(),
        rawDate.getUTCMonth(),
        rawDate.getUTCDate(),
        startHour,
        startMinute,
        0,
        0,
      );

      return now >= slotDate;
    } catch (e) {
      return false;
    }
  };

  const fetchBookedSlots = async () => {
    try {
      const res = await api.get("/booking", {
        params: { studentId: user._id },
      });
      if (res.data.success) {
        setBookedSlots(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch booked slots:", err);
    }
  };

  useEffect(() => {
    if (user && user._id) fetchBookedSlots();
  }, [user]);

  const openCommentModal = (slot) => {
    setCurrentSlot(slot);
    setCommentModal(true);
  };
  const openSlotModal = (slot) => {
    setCurrentSlot(slot);
    setModalOpen(true);
  };
  const formatBookingDate = (isoDate) => {
    if (!isoDate) return "N/A";
    const date = new Date(isoDate); // ISO string from MongoDB
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString(undefined, options); // e.g., "Apr 6, 2026"
  };
  const getTeacherName = (slot) => slot?.teacherId?.userId?.name || "N/A";
  const getTeacherEmail = (slot) => slot?.teacherId?.userId?.email || "N/A";
  const getDate = (slot) => formatBookingDate(slot.date);
  const getDuration = (slot) =>
    slot?.duration ? `${slot.duration} min` : "N/A";
  console.log(bookedSlots);

  const addComment = async (slot) => {
    try {
      const payload = {
        studentId: slot.studentId._id,
        teacherId: slot.teacherId._id,
        bookingId: slot._id,
        comment: comment,
      };

      const res = await api.post("/review", payload);

      if (res.data.success) {
        toast.success("Review added successfully");
        setComment("");
        setCommentModal(false);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Review Error:", err);

      // ✅ handle backend error message
      const message =
        err.response?.data?.message || "Server error. Please try again.";

      toast.error(message);
    }
  };

  return (
    <div className="overview-container">
      <h2>My Booked Sessions</h2>

      {bookedSlots.length > 0 ? (
        <div className="table-responsive">
          {/* Desktop Table */}
          <table className="lessons-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Time</th>
                <th>Duration</th>
                <th>Teacher</th>
                <th>Status</th>
                <th>Action</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              {bookedSlots.map((slot, idx) => {
                const expired = isSlotExpired(slot);
                return (
                  <tr key={slot._id || idx}>
                    <td>{idx + 1}</td>
                    <td>{getDate(slot)}</td>
                    <td>{formatSlotTime(slot.time, slot.duration)}</td>
                    <td>{getDuration(slot)}</td>
                    <td>{getTeacherName(slot)}</td>
                    <td>
                      <span
                        style={{
                          color: expired ? "#ef4444" : "#22c55e",
                          fontWeight: 500,
                          fontSize: "13px",
                          textTransform: "capitalize",
                        }}
                      >
                        {slot.status}
                      </span>
                    </td>
                    <td>
                      {expired || slot.status === "completed" ? (
                        <button className="lesson-btn expired" disabled>
                          Completed
                        </button>
                      ) : (
                        <button
                          className="lesson-btn"
                          onClick={() => openSlotModal(slot)}
                        >
                          Join
                        </button>
                      )}
                    </td>
                    <td>
                      {slot.status === "completed" ? (
                        <button
                          onClick={() => openCommentModal(slot)}
                          style={{
                            padding: "10px 18px",
                            borderRadius: "10px",
                            border: "none",
                            background:
                              "linear-gradient(135deg, #4CAF50, #2E7D32)",
                            color: "#fff",
                            fontWeight: "600",
                            fontSize: "14px",
                            cursor: "pointer",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                            transition: "all 0.3s ease",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        >
                          Leave A Review
                        </button>
                      ) : (
                        <button
                          disabled
                          style={{
                            padding: "10px 18px",
                            borderRadius: "10px",
                            border: "none",
                            background: "#ccc",
                            color: "#666",
                            fontWeight: "600",
                            fontSize: "14px",
                            cursor: "not-allowed",
                            opacity: 0.7,
                          }}
                        >
                          Leave A Review
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Mobile Cards */}
          <div className="cards-container">
            {bookedSlots.map((slot, idx) => {
              const expired = isSlotExpired(slot);
              return (
                <div className="slot-card" key={"card-" + idx}>
                  <p>
                    <strong>No:</strong> {idx + 1}
                  </p>
                  <p>
                    <strong>Date:</strong> {getDate(slot)}
                  </p>
                  <p>
                    <strong>Time:</strong>{" "}
                    {formatSlotTime(slot.time, slot.duration)}
                  </p>
                  <p>
                    <strong>Duration:</strong> {getDuration(slot)}
                  </p>
                  <p>
                    <strong>Teacher:</strong> {getTeacherName(slot)}
                  </p>
                  <p>
                    <strong>Email:</strong> {getTeacherEmail(slot)}
                  </p>
                  <p>
                    <strong>Status: </strong>
                    <span style={{ color: expired ? "#ef4444" : "#22c55e" }}>
                      {expired ? "Completed" : "Upcoming"}
                    </span>
                  </p>
                  <button
                    className="lesson-btn"
                    disabled={expired}
                    onClick={() => {
                      if (!expired) openSlotModal(slot);
                    }}
                  >
                    {expired ? "Completed" : "Join"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
            padding: "3rem 2rem",
            background: "#111",
            borderRadius: "12px",
            border: "1px solid #333",
            marginTop: "1rem",
          }}
        >
          <p style={{ fontSize: "2rem", marginBottom: "1rem" }}>📅</p>
          <p style={{ color: "#888", marginBottom: "1rem" }}>
            No booked sessions found.
          </p>
          <p style={{ color: "#555", fontSize: "13px" }}>
            Book a lesson with a teacher to get started!
          </p>
        </div>
      )}

      {/* Modal */}
      {modalOpen && currentSlot && (
        <div
          className="video-modal-overlay"
          onClick={() => setModalOpen(false)}
        >
          <div
            className="video-modal-content responsive-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <h3 style={{ margin: 0, color: "#000" }}>Session Details</h3>
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer", color: "#000" }}
                onClick={() => setModalOpen(false)}
              />
            </div>

            <div style={{ padding: "0.5rem 0 1rem" }}>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Teacher: </strong>
                <span style={{ color: "#000" }}>
                  {getTeacherName(currentSlot)}
                </span>
              </p>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Date: </strong>
                <span style={{ color: "#000" }}>{getDate(currentSlot)}</span>
              </p>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Time: </strong>
                <span style={{ color: "#000" }}>
                  {formatSlotTime(currentSlot.time, currentSlot.duration)}
                </span>
              </p>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Duration: </strong>
                <span style={{ color: "#000" }}>
                  {getDuration(currentSlot)}
                </span>
              </p>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Teacher Email: </strong>
                <span style={{ color: "#000" }}>
                  {getTeacherEmail(currentSlot)}
                </span>
              </p>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Status: </strong>
                <span
                  style={{
                    color:
                      currentSlot.status === "confirmed"
                        ? "#22c55e"
                        : "#f59e0b",
                    fontWeight: 600,
                  }}
                >
                  {currentSlot.status || "N/A"}
                </span>
              </p>
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {currentSlot.zoomJoinUrl ? (
                <a
                  href={currentSlot.zoomJoinUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "block",
                    textAlign: "center",
                    padding: "12px",
                    borderRadius: "8px",
                    background: "#2563eb",
                    color: "#fff",
                    fontWeight: 600,
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                >
                  🎥 Join Zoom Meeting
                </a>
              ) : (
                <div
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    background: "#1a1a1a",
                    border: "1px solid #333",
                    color: "#888",
                    fontSize: "13px",
                    textAlign: "center",
                  }}
                >
                  Zoom link not available yet
                </div>
              )}

              {currentSlot.recordingUrl && (
                <a
                  href={currentSlot.recordingUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "block",
                    textAlign: "center",
                    padding: "12px",
                    borderRadius: "8px",
                    background: "#6366f1",
                    color: "#fff",
                    fontWeight: 600,
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                >
                  Watch Recording
                </a>
              )}

              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "12px",
                  borderRadius: "8px",
                  background: "#333",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "14px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Comment Modal */}
      {commentModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setCommentModal(false)}
        >
          <div
            className="video-modal-content responsive-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <h3 style={{ margin: 0, color: "#000" }}>
                Share Your Experience
              </h3>
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer", color: "#000" }}
                onClick={() => setCommentModal(false)}
              />
            </div>

            <div style={{ padding: "0.5rem 0 1rem" }}>
              <p style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#9ca3af" }}>Teacher: </strong>
                <span style={{ color: "#000" }}>
                  {getTeacherName(currentSlot)}
                </span>
              </p>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                width: "100%",
              }}
            >
              {/* Input Field */}
              <textarea
                placeholder="Write your comment..."
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #ddd",
                  outline: "none",
                  fontSize: "14px",
                  resize: "none",
                  boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                  transition: "0.3s",
                }}
                onFocus={(e) => (e.target.style.border = "1px solid #4CAF50")}
                onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />

              {/* Comment Button */}
              <button
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #2196F3, #1976D2)",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
                onClick={() => addComment(currentSlot)}
              >
                Submit Comment
              </button>

              {/* Close Button */}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  background: "#333",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: "14px",
                  transition: "0.3s",
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = "#000")}
                onMouseOut={(e) => (e.currentTarget.style.background = "#333")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Upcoming;
